import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-table-footer',
  template: `
    <mat-paginator
      [length]="length"
      [pageSize]="pageSize"
      (page)="selectPage($event)"
      aria-label="Select page"
    >
    </mat-paginator>
  `,
})
export class TableFooterComponent implements OnInit {
  @Input() meta; //  private
  // @Input() filterCriteria;

  @Output() private selectedPage = new EventEmitter<any>(); // string obg two params

  length: number;
  pageSize: number;

  ngOnInit(): void {
    this.length = this.meta.itemsFound;
    this.pageSize = this.meta.itemsPerPage;
    // pageSizeOptions: number[] = [5, 10, 25, 100];
  }

  selectPage(obj) {
    let page = obj.pageIndex + 1;
    let offset = (page - 1) * parseInt(this.meta.itemsPerPage);

    this.selectedPage.emit({ page, offset });
  }
}
